import { MultilingualString } from "features/shared/types/string";
import { ColumnGroup } from "../types/subproductTable";

export const extractColumnGroupsFromMultilingualStrings = (
    strArr: MultilingualString[]
): ColumnGroup[] => {
    const columnGroups = strArr.reduce(
        (acc: ColumnGroup[], curr: MultilingualString) => {
            const prev = acc[acc.length - 1];
            if (prev && prev.name.en === curr.en && prev.name.th === curr.th) {
                // both languages must match
                return [
                    ...acc.slice(0, -1),
                    {
                        name: curr,
                        columnSize: prev.columnSize + 1,
                    },
                ];
            }
            return [
                ...acc,
                {
                    name: curr,
                    columnSize: 1,
                },
            ];
        },
        []
    );
    return columnGroups;
};

export const extractMultilingualStringsFromColumnGroups = (
    columnGroups: ColumnGroup[],
    forcedSize?: number
): MultilingualString[] => {
    const strArr = columnGroups.flatMap((columnGroup) => {
        return Array(columnGroup.columnSize).fill(columnGroup.name);
    });
    if (forcedSize && strArr.length < forcedSize) {
        const diff = forcedSize - strArr.length;
        return [...strArr, ...Array(diff).fill({ en: "", th: "" })];
    }
    return strArr;
};
